// extracted by mini-css-extract-plugin
export var borderRadius = "_6u-4";
export var large = "_6u-3";
export var logoContainer = "_6u-0";
export var nameLogo = "_6u-2";
export var small = "_6u-1";